import { useEffect, useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

import DataTable from '../../../../../../componentsV2/DataTable/DataTable'

import { dateFormatter } from '../../../../../../utils/date'
import {
    defaultPerPage,
    showList,
} from '../../../../../../enums/planogramTypes'

const SnapShotListTable = ({
    t,
    isRTL,
    dmode,
    responseData = [],
    filterState,
    submitFunc,
    // confirmModalShow,
    getSelectRowData,
}) => {
    const [data, setData] = useState(responseData.extra)
    const [selectedRows, setSelectedRows] = useState([])

    const [total, setTotal] = useState(0)
    const [startIndex, setStartIndex] = useState(0)
    const [page, setPage] = useState(1)

    useEffect(() => {
        setData(responseData?.extra)
        setTotal(responseData?.count)
        // Reset to first page when new filter results are received
        // if (responseData?.extra && filterState?.startIndex === 0) {
        //     // setPage(1)
        //     setStartIndex(0)
        // }
    }, [responseData])

    // Formatter function to show array data as comma-separated values
    const tagsFormatter = (cell) => {
        return cell && cell.length > 0 ? limitAttributeContent(cell) : '-'
    }

    //simulation table headers & keys
    const simulationColumns = [
        {
            dataField: 'departmentName',
            text: t('department'),
        },
        {
            dataField: 'editionName',
            text: t('EDITION'),
        },
        {
            dataField: 'fieldCount',
            text: t('fields'),
            headerStyle: { width: '100px' },
            style: () => {
                return { fontWeight: '700' }
            },
        },
        {
            dataField: 'totalWidth',
            text: t('width'),
            headerStyle: { width: '100px' },
            formatter: (cell, row) => {
                if (typeof cell === 'number' && !isNaN(cell)) {
                    if (cell % 1 !== 0) {
                        return `${cell.toFixed(0)} ${t('uomlist.CM_SHORT')}`
                    }
                    return `${cell} cm`
                } else {
                    return `cm`
                }
            },
        },
        {
            dataField: 'lastModifiedDate',
            text: t('LAST_MODIFIED'),
            headerStyle: { width: '150px' },
            formatter: dateFormatter,
        },
        {
            dataField: 'attributes',
            text: t('Attributes'),
            formatter: tagsFormatter,
        },
    ]

    const mekeReportModalShowClick = (row_id) => {}

    //row selection option
    const onSelect = (row, isSelect, rowIndex, e) => {}

    const handlePagination = (page) => {
        // console.log('page', page);
        
        const newStartIndex = (page - 1) * defaultPerPage.PER_PAGE
        setStartIndex(newStartIndex)
        setPage(page)
        const updatedFilterState = { ...filterState, startIndex: newStartIndex }
        submitFunc(updatedFilterState)
        // dispatch(selectRowAction({ type: SELECT_ROW_SET, payload: 0 }))
    }

    const handleTableChange = (type, { sortField, sortOrder }) => {}

    const handleRowClick = (row) => {
        getSelectRowData(row)
        // confirmModalShow()
    }

    return (
        <div>
            <DataTable
                isRTL={isRTL}
                columns={simulationColumns}
                listKey={'id'}
                data={data}
                onButtonClick={mekeReportModalShowClick}
                onSelect={onSelect}
                selectedRows={selectedRows}
                dmode={dmode}
                total={total}
                responsive
                filters={filterState}
                handlePagination={handlePagination}
                startIndex={startIndex}
                setPage={setPage}
                page={page}
                setSelectedRows={setSelectedRows}
                handleTableChange={handleTableChange}
                showListProp={showList.SIMULATION_LIST}
                isOnClickEnable={true}
                onClickCallbackFunc={(row) => handleRowClick(row)}
            />
        </div>
    )
}

export default SnapShotListTable

export const limitAttributeContent = (cell) => {
    const MAX_LENGTH = 50 // Limit to 50 characters
    const tooltipContent = cell.join(', ')

    if (tooltipContent.length > MAX_LENGTH) {
        const visiblePart = tooltipContent.slice(0, MAX_LENGTH)
        const remainingPart = tooltipContent.slice(MAX_LENGTH)

        return (
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id="tooltip-remaining-content">
                        {remainingPart}
                    </Tooltip>
                }
            >
                <span>{visiblePart}</span>
            </OverlayTrigger>
        )
    }
    // If content is within the limit, just show the full content
    return tooltipContent
}
